import "../../Styles/dashboard/sidebar.css"
import { Avatar } from '@mantine/core';
import logo from "../../assets/images/logo3.jpg"
import { NavLink, useNavigate } from "react-router-dom";
import {LuLayoutDashboard} from "react-icons/lu"
import {BsBoxSeam} from "react-icons/bs"
import {GiShoppingBag} from "react-icons/gi"
import {FaRegNewspaper} from "react-icons/fa"
import {RiSettings2Line} from "react-icons/ri"
import {AiOutlineAudit} from "react-icons/ai"
import {BiLogOut} from "react-icons/bi"
import { useEffect, useState } from "react";
import { Burger } from '@mantine/core';
import Cookies from "js-cookie";
import axios from "axios";
import { url } from "../../db/url";

const Sidebar = () => {

    const [navOpened, setOpened] = useState(false);
    const[details, setDetails] =  useState({
        username: "",
        image: ""
    })
    const navigate = useNavigate()
    
    const activeStyle = {
        backgroundColor: "rgba(0, 128, 0, 0.127)",
        borderRight: "4px solid green"
    }
    

    useEffect(() => {
        axios.get(`${url}/api/v2/`, {headers: {Authorization: `Bearer ${Cookies.get('USER_TOKEN')}`}})
        .then((response) => {
            setDetails({
                username: response.data.username,
                image: response.data.image
            })
        })
        .catch((error) => {
            console.log("Sorry An error occured while fetching admin details")
        })
    }, [])


    return<>
        <div className="navBar">
            <form action="">
                <Burger className="burger" opened={navOpened} onClick={() => navOpened ? setOpened(false) : setOpened(true)} color="black" size="sm"/>
            
                <input type="search" name="" id="" placeholder="Search"/>
            </form>
            <div className="profileInfo">
                <Avatar color="cyan" radius="xl" src={details.image}></Avatar>
                <p>{details.username}</p>
            </div>
        </div>

        <div className={!navOpened && window.innerWidth <= 1000 ? "hide" : "dashboardSidebar"}>
            <div className="topNav">
                <div className="logo">
                    <img src={logo} alt="" />
                </div>
                <div className="menuList">
                    <NavLink to={"/dashboard"}  style = {({isActive}) => isActive? activeStyle : undefined} end>
                        <LuLayoutDashboard/>
                        <p>Dashboard</p>
                    </NavLink>
                    <NavLink to={"/dashboard/product"} style = {({isActive}) => isActive? activeStyle : undefined} end>
                        <BsBoxSeam/>
                        <p>Products</p>
                    </NavLink>
                    <NavLink  to={"/dashboard/orders"} style = {({isActive}) => isActive? activeStyle : undefined} end>
                        <GiShoppingBag/>
                        <p>Orders</p>
                    </NavLink>
                </div>
            </div>
            <div className="bottomNav">
                <NavLink  to={"/dashboard/settings"} style = {({isActive}) => isActive? activeStyle : undefined} end>
                    <RiSettings2Line/>
                    <p>Settings</p>
                </NavLink>
                <div className="logout" >
                    <BiLogOut/>
                    <p>Log Out</p>
                </div>
            </div>
        </div>
    </>
    
}

export default Sidebar